
define("rv!templates/partials/availableRoomList",[],function(){return { v:3,
  t:[ { t:7,
      e:"div",
      f:[ { t:7,
          e:"div",
          a:{ id:"available-room-list",
            "class":"row" },
          f:[ { t:4,
              f:[ { t:7,
                  e:"div",
                  a:{ "class":"alert alert-info" },
                  f:[ "Press \"Check Availability\" to check room availability for your new criteria." ] } ],
              n:50,
              x:{ r:[ "availability.Rooms" ],
                s:"_0==null" } },
            { t:4,
              n:51,
              f:[ { t:4,
                  n:50,
                  x:{ r:[ "availability.Rooms.length" ],
                    s:"_0==0" },
                  f:[ { t:7,
                      e:"div",
                      a:{ "class":"alert alert-info" },
                      f:[ "No rooms were found for the selected travelers and dates." ] } ] } ],
              x:{ r:[ "availability.Rooms" ],
                s:"_0==null" } },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"div",
                  a:{ id:"available-room-card",
                    "class":"span5" },
                  f:[ { t:7,
                      e:"div",
                      a:{ style:"\r\n                background-color: white;\r\n                box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n                border-radius: 10px;\r\n                margin: 10px;\r\n            " },
                      f:[ { t:7,
                          e:"div",
                          a:{ "class":"room-image-container" },
                          f:[ " ",
                            { t:4,
                              f:[ { t:7,
                                  e:"img",
                                  a:{ style:"width: 100%; height: 100%;",
                                    src:[ { t:2,
                                        r:"contentUrl" },
                                      "images/hotelphotos/no-image.png" ],
                                    "data-original":[ { t:2,
                                        r:"RoomImage" } ],
                                    alt:"no room image" } } ],
                              n:50,
                              x:{ r:[ "RoomImage" ],
                                s:"_0==\"\"||_0==null" } },
                            { t:4,
                              n:51,
                              f:[ { t:7,
                                  e:"img",
                                  a:{ style:"width: 100%; height: 100%;",
                                    src:[ { t:2,
                                        r:"RoomImage" } ],
                                    alt:"room image" } } ],
                              x:{ r:[ "RoomImage" ],
                                s:"_0==\"\"||_0==null" } } ] },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ style:"padding-top: 10px; padding-left: 20px; padding-right: 20px; text-align: left;" },
                          f:[ { t:7,
                              e:"h3",
                              a:{ style:"text-align: center;" },
                              f:[ { t:2,
                                  r:"Name" } ] },
                            " ",
                            { t:7,
                              e:"div",
                              a:{ style:"margin-top: 20px; margin-bottom: 20px;" },
                              f:[ { t:7,
                                  e:"ul",
                                  f:[ { t:7,
                                      e:"li",
                                      f:[ { t:3,
                                          r:"Desc" } ] } ] } ] } ] },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ style:"width: 100%; background-color: #f5f5f5; text-align: left; display: flex; flex-direction: row; justify-content: flex-start; align-items: center;" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"#perfectSaver",
                                "class":"infoLink",
                                style:"padding-left: 20px;",
                                "data-track":[ "Room_Selection,PerfectSaver,RibbonClick,",
                                  { t:2,
                                    x:{ r:[ "@index" ],
                                      s:"_0+1" } } ] },
                              f:[ { t:7,
                                  e:"img",
                                  a:{ src:[ { t:2,
                                        r:"contentUrl" },
                                      "images/destinationimages/page/",
                                      { t:2,
                                        x:{ r:[ "PsPreviewAmount" ],
                                          s:"_0>0?\"perfectsaver_purple_nospace.png?v=2\":\"perfectsaver_green_nospace.png?v=4\"" } } ],
                                    alt:"PerfectSaver",
                                    style:"height: 32px; width: auto;" } } ] },
                            " ",
                            { t:7,
                              e:"div",
                              a:{ style:"padding-left: 5px;" },
                              f:[ { t:7,
                                  e:"strong",
                                  f:[ { t:2,
                                      r:"PerfectSaverMessage" } ] },
                                " ",
                                { t:7,
                                  e:"a",
                                  a:{ href:"#perfectSaver",
                                    "class":"infoLink",
                                    "data-track":[ "Room_Selection,PerfectSaver,HelpClick,",
                                      { t:2,
                                        x:{ r:[ "@index" ],
                                          s:"_0+1" } } ] },
                                  f:[ { t:7,
                                      e:"img",
                                      a:{ src:[ { t:2,
                                            r:"contentUrl" },
                                          "images/ico-question.png" ],
                                        alt:"what's this" } } ] } ] } ] },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ id:"perfectSaver",
                            "class":"infoBox ps-infobox" },
                          f:[ { t:7,
                              e:"img",
                              a:{ src:[ { t:2,
                                    r:"contentUrl" },
                                  "images/destinationimages/page/perfectsaver_green_nospace.png?v=4" ],
                                alt:"PerfectSaver",
                                id:"imgPerfectSaver" } },
                            " ",
                            { t:7,
                              e:"br" },
                            { t:7,
                              e:"br" },
                            " ",
                            { t:4,
                              f:[ "This page shows an estimated price that does not include taxes and does not account for potential nightly rate changes. ",
                                { t:7,
                                  e:"br" },
                                { t:7,
                                  e:"br" },
                                " Click \"Choose\" to make PerfectSaver calculate exactly what you'll need to save to pay for this room." ],
                              n:50,
                              x:{ r:[ "isLinked" ],
                                s:"_0()" } },
                            " ",
                            { t:4,
                              f:[ "This is the amount you'd need to save with Adestinn per month for a year, for each night, to book this room. ",
                                { t:7,
                                  e:"br" },
                                { t:7,
                                  e:"br" },
                                " To book, you'll need to link your bank account ",
                                { t:7,
                                  e:"br" },
                                { t:7,
                                  e:"br" },
                                " ",
                                { t:7,
                                  e:"a",
                                  a:{ "class":"btn btn-primary",
                                    href:"/MyAccount/FinancialAccount.aspx?r=t",
                                    "data-track":"RoomSelection,LinkAccount,Click,1" },
                                  f:[ "Link My Bank Account" ] } ],
                              n:50,
                              x:{ r:[ "isLinked" ],
                                s:"!_0()" } } ] },
                        " ",
                        { t:4,
                          f:[ { t:7,
                              e:"div",
                              a:{ "class":"hotelbeds-promotions-offers",
                                style:"padding-top: 10px; font-style: italic;" },
                              f:[ { t:4,
                                  f:[ { t:7,
                                      e:"span",
                                      a:{ "class":"alert-promotions-offers" },
                                      f:[ "This room includes ",
                                        { t:7,
                                          e:"a",
                                          a:{ href:[ "#promotionsOffers-",
                                              { t:2,
                                                r:"@index" } ],
                                            "class":"infoLink" },
                                          f:[ "Promotions & Offers" ] } ] } ],
                                  n:50,
                                  x:{ r:[ ".Promotions",
                                      ".Offers" ],
                                    s:"_0&&_1" } },
                                { t:4,
                                  n:51,
                                  f:[ { t:4,
                                      n:50,
                                      x:{ r:[ ".Promotions" ],
                                        s:"_0" },
                                      f:[ { t:7,
                                          e:"span",
                                          a:{ "class":"alert-promotions-offers" },
                                          f:[ "This room includes ",
                                            { t:7,
                                              e:"a",
                                              a:{ href:[ "#promotionsOffers-",
                                                  { t:2,
                                                    r:"@index" } ],
                                                "class":"infoLink" },
                                              f:[ "Promotions" ] } ] } ] },
                                    { t:4,
                                      n:50,
                                      x:{ r:[ ".Promotions" ],
                                        s:"!(_0)" },
                                      f:[ " ",
                                        { t:7,
                                          e:"span",
                                          a:{ "class":"alert-promotions-offers" },
                                          f:[ "This room includes ",
                                            { t:7,
                                              e:"a",
                                              a:{ href:[ "#promotionsOffers-",
                                                  { t:2,
                                                    r:"@index" } ],
                                                "class":"infoLink" },
                                              f:[ "Offers" ] } ] } ] } ],
                                  x:{ r:[ ".Promotions",
                                      ".Offers" ],
                                    s:"_0&&_1" } },
                                " ",
                                { t:7,
                                  e:"div",
                                  a:{ id:[ "promotionsOffers-",
                                      { t:2,
                                        r:"@index" } ],
                                    "class":"infoBox ps-infobox promotion-offer-container" },
                                  f:[ { t:4,
                                      f:[ { t:7,
                                          e:"h4",
                                          f:[ "Promotions" ] },
                                        " ",
                                        { t:7,
                                          e:"ul",
                                          f:[ { t:4,
                                              f:[ { t:7,
                                                  e:"li",
                                                  f:[ { t:2,
                                                      r:".Name" } ] } ],
                                              n:52,
                                              r:".Promotions" } ] } ],
                                      n:50,
                                      r:".Promotions" },
                                    " ",
                                    { t:4,
                                      f:[ { t:7,
                                          e:"h4",
                                          f:[ "Offers" ] },
                                        " ",
                                        { t:7,
                                          e:"ul",
                                          f:[ { t:4,
                                              f:[ { t:7,
                                                  e:"li",
                                                  f:[ { t:2,
                                                      r:".Name" },
                                                    " : ",
                                                    { t:2,
                                                      r:".Amount" } ] } ],
                                              n:52,
                                              r:".Offers" } ] } ],
                                      n:50,
                                      r:".Offers" } ] } ] } ],
                          n:50,
                          x:{ r:[ ".Promotions",
                              ".Offers" ],
                            s:"_0||_1" } },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ style:"padding-top: 10px; padding-left: 20px; padding-right: 20px; padding-bottom: 20px; text-align: left;" },
                          f:[ { t:7,
                              e:"div",
                              a:{ style:"display: flex; flex-direction: row; justify-content: space-between; align-items: center; align-content: center;" },
                              f:[ { t:7,
                                  e:"div",
                                  f:[ { t:7,
                                      e:"span",
                                      a:{ style:"font-size: 18px; font-weight: bold" },
                                      f:[ { t:2,
                                          x:{ r:[ "formatMoney",
                                              "Rate" ],
                                            s:"_0(_1)" } } ] },
                                    " avg/night ",
                                    { t:7,
                                      e:"h6",
                                      a:{ style:"align-content: center; align-items: center;" },
                                      f:[ { t:7,
                                          e:"a",
                                          v:{ click:{ n:"onGetRateDetails",
                                              d:[ { t:2,
                                                  r:"@index" } ] } },
                                          a:{ style:"cursor: pointer;" },
                                          f:[ "price details" ] },
                                        " ",
                                        { t:4,
                                          f:[ { t:7,
                                              e:"div",
                                              a:{ style:"display: inline; margin-left: 20px;" },
                                              f:[ { t:7,
                                                  e:"img",
                                                  a:{ id:"homeLoadIMG",
                                                    style:"width: 24px; height: 24px; margin-bottom: 7px;",
                                                    src:"https://adestinn2blob.blob.core.windows.net/images/loading12102015-2.gif" } } ] } ],
                                          n:50,
                                          r:"loadingRateDetails" } ] } ] },
                                " ",
                                { t:7,
                                  e:"a",
                                  a:{ href:[ { t:2,
                                        r:"BookingUrl" } ],
                                    "class":"btn btn-primary",
                                    style:"font-weight: bold; display: flex; align-items: center; height: 20px;" },
                                  f:[ "Choose" ] } ] } ] } ] } ] } ],
              r:"availability.Rooms" },
            " ",
            { t:7,
              e:"div",
              a:{ id:"nightly-rate-modal",
                "class":"infobox ps-infobox" },
              f:[ { t:4,
                  f:[ { t:4,
                      n:53,
                      f:[ { t:8,
                          r:"nightlyRates" } ],
                      r:"RateDetails" } ],
                  n:50,
                  x:{ r:[ "RateDetails.Nights",
                      "RateDetails.Nights.length" ],
                    s:"_0!=null&&_1>0" } },
                { t:4,
                  n:51,
                  f:[ { t:4,
                      n:53,
                      f:[ { t:8,
                          r:"messenger" } ],
                      r:"RateDetailsErrors" } ],
                  x:{ r:[ "RateDetails.Nights",
                      "RateDetails.Nights.length" ],
                    s:"_0!=null&&_1>0" } },
                " ",
                { t:7,
                  e:"br" } ] } ] } ] } ] };});
